import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import PublicNav from '../components/layout/PublicNav';
import PublicFooter from '../components/layout/PublicFooter';

const SERVICES = [
  {
    id: 'loans', icon: '⚡', name: 'Quick Loans',
    desc: 'Access personal, business & emergency loans up to ₦5M within 24 hours. Simple KYC, transparent rates, and instant decisions — no paperwork, no long queues.',
    color: '#00C896', bg: 'rgba(0,200,150,0.1)', border: 'rgba(0,200,150,0.2)', live: true, to: '/loans/apply', cta: 'Apply for a loan',
  },
  {
    id: 'airtime', icon: '📱', name: 'Airtime',
    desc: 'Top up airtime for MTN, Airtel, Glo & 9mobile instantly at the best rates, right from your PCredit balance.',
    color: '#818CF8', bg: 'rgba(129,140,248,0.1)', border: 'rgba(129,140,248,0.2)', live: false,
  },
  {
    id: 'data', icon: '🌐', name: 'Data Bundles',
    desc: 'Purchase data plans for all Nigerian networks. Fast, hassle-free, and available for every plan size.',
    color: '#5B8EFF', bg: 'rgba(91,142,255,0.1)', border: 'rgba(91,142,255,0.2)', live: false,
  },
  {
    id: 'electricity', icon: '💡', name: 'Electricity',
    desc: 'Pay PHCN / EKEDC / IBEDC bills and get your prepaid token instantly, without leaving the app.',
    color: '#F5A623', bg: 'rgba(245,166,35,0.1)', border: 'rgba(245,166,35,0.2)', live: false,
  },
  {
    id: 'cable-tv', icon: '📺', name: 'Cable TV',
    desc: 'Renew DStv, GOtv, Startimes & Showmax subscriptions in seconds, with reminders before they expire.',
    color: '#FF6B6B', bg: 'rgba(255,107,107,0.1)', border: 'rgba(255,107,107,0.2)', live: false,
  },
  {
    id: 'credit-report', icon: '📊', name: 'Credit Report',
    desc: 'Check your credit score and history, and get clear tips to improve your borrowing power over time.',
    color: '#00C8D4', bg: 'rgba(0,200,212,0.1)', border: 'rgba(0,200,212,0.2)', live: true, to: '/credit-report', cta: 'Get my credit report',
  },
  {
    id: 'savings', icon: '💰', name: 'Savings Plans',
    desc: 'Set a goal, contribute on your own schedule, and build a Trust Score that unlocks early access to your funds via a Progress Card or fee-based Plan Advance.',
    color: '#1596E0', bg: 'rgba(21,150,224,0.1)', border: 'rgba(21,150,224,0.2)', live: true, to: '/contributions/new', cta: 'Start a savings plan',
  },
  {
    id: 'group-ajo', icon: '👥', name: 'Group Ajo',
    desc: 'Join or start a rotating group contribution circle — everyone pays in on schedule, and the pot rotates until every member has been paid.',
    color: '#F5A623', bg: 'rgba(245,166,35,0.1)', border: 'rgba(245,166,35,0.2)', live: true, to: '/groups/new', cta: 'Start a group',
  },
];

export default function Services() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
    }
  }, [hash]);

  return (
    <div style={{ background: 'transparent', color: 'var(--text-1)', minHeight: '100vh', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <PublicNav />

      <main style={{ flex: 1 }}>

      <section style={{ padding: '4.5rem 5% 3rem', textAlign: 'center' }}>
        <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#00C896', textTransform: 'uppercase', letterSpacing: '0.12em', marginBottom: '0.75rem' }}>Our Services</div>
        <h1 style={{ fontSize: 'clamp(1.8rem,3.5vw,2.6rem)', fontWeight: 900, fontFamily: 'Space Grotesk, sans-serif', letterSpacing: '-0.02em', marginBottom: '1rem' }}>
          Everything You Need, One Platform
        </h1>
        <p style={{ fontSize: '1rem', color: 'var(--text-2)', lineHeight: 1.75, maxWidth: 620, margin: '0 auto' }}>
          From instant loans to utility payments and group savings, here's a closer look at everything PCredit offers.
        </p>
      </section>

      <section style={{ padding: '0 5% 5rem' }}>
        <div style={{ maxWidth: 800, margin: '0 auto', display: 'grid', gap: '1.25rem' }}>
          {SERVICES.map(({ id, icon, name, desc, color, bg, border, live, to, cta }) => (
            <div key={id} id={id} style={{ scrollMarginTop: 100, padding: '1.75rem', background: 'var(--surface)', border: `1px solid ${border}`, borderRadius: 16, display: 'flex', gap: '1.25rem', alignItems: 'flex-start', flexWrap: 'wrap' }}>
              <div style={{ width: 52, height: 52, borderRadius: 14, background: bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.5rem', flexShrink: 0 }}>{icon}</div>
              <div style={{ flex: 1, minWidth: 200 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '0.4rem', flexWrap: 'wrap' }}>
                  <h2 style={{ fontSize: '1.15rem', fontWeight: 700 }}>{name}</h2>
                  <span style={{ fontSize: '0.65rem', fontWeight: 700, padding: '2px 8px', borderRadius: 99, background: live ? 'rgba(0,200,150,0.15)' : 'rgba(255,255,255,0.06)', color: live ? color : 'var(--text-3)' }}>
                    {live ? 'Live' : 'Coming Soon'}
                  </span>
                </div>
                <p style={{ fontSize: '0.88rem', color: 'var(--text-2)', lineHeight: 1.65, marginBottom: live ? '0.9rem' : 0 }}>{desc}</p>
                {live && (
                  <Link to={to} style={{ fontSize: '0.85rem', fontWeight: 700, color }}>{cta} →</Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      </main>

      <PublicFooter />
    </div>
  );
}
